// extracted by mini-css-extract-plugin
export default {"link":"DF9NQC","root":"I0Z1hF","bg":"SdUQJg","label":"NmszKH","top":"J5uOBX","bottom":"fFDpax"};